// src/auth/authStorage.js

const ACCESS_TOKEN_KEY = "token";
const REFRESH_TOKEN_KEY = "refreshToken";
const AUTH_EVENT = "santsystem:auth-changed";

function getStorage() {
  return typeof window !== "undefined"
    ? window.sessionStorage
    : null;
}

export function getAccessToken() {
  return getStorage()?.getItem(ACCESS_TOKEN_KEY) || "";
}

export function getRefreshToken() {
  return getStorage()?.getItem(REFRESH_TOKEN_KEY) || "";
}

export function setAuthTokens({ token, refreshToken }) {
  const storage = getStorage();
  if (!storage) return;

  if (token) {
    storage.setItem(ACCESS_TOKEN_KEY, token);
  } else {
    storage.removeItem(ACCESS_TOKEN_KEY);
  }

  if (refreshToken) {
    storage.setItem(REFRESH_TOKEN_KEY, refreshToken);
  } else {
    storage.removeItem(REFRESH_TOKEN_KEY);
  }

  window.dispatchEvent(new CustomEvent(AUTH_EVENT));
}

export function clearAuthSession() {
  const storage = getStorage();
  if (!storage) return;

  // Remove somente autenticação.
  // Não usar storage.clear(), pois isso apagaria
  // outros dados e também o log de diagnóstico.
  storage.removeItem(ACCESS_TOKEN_KEY);
  storage.removeItem(REFRESH_TOKEN_KEY);

  window.dispatchEvent(new CustomEvent(AUTH_EVENT));
}

export function hasAuthSession() {
  return Boolean(
    getAccessToken() ||
    getRefreshToken()
  );
}

export function subscribeAuthChanges(callback) {
  if (typeof window === "undefined") return () => {};

  const handler = () => callback?.();

  window.addEventListener(AUTH_EVENT, handler);
  window.addEventListener("storage", handler);

  return () => {
    window.removeEventListener(AUTH_EVENT, handler);
    window.removeEventListener("storage", handler);
  };
}
